export default __webpack_public_path__ + "static/media/sam.32c8ad49.jpeg";